export default {"src":"/_next/static/media/es.21e646b6.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};